import React, { useEffect, useRef } from 'react';
import WarehouseSection from '../components/WarehouseSection';
import WhyGloboflo from '../components/WhyGloboflo';

const HomePage = ({ hero, rotating, solutions, features }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      // Immediately mark as revealed for accessibility
      root.querySelectorAll('.anim').forEach((el) => el.classList.add('in'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    root.querySelectorAll('.anim').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="home" ref={containerRef}>
      <div className="anim in">{hero}</div>
      <div className="anim in"><WhyGloboflo /></div>
      <div className="anim delay-1">{rotating}</div>
      <div className="anim delay-2">{solutions}</div>
      <div className="anim delay-3"><WarehouseSection /></div>
      <div className="anim delay-4">{features}</div>
    </main>
  );
};

export default HomePage;



